<div class="page">
  <app-page-header page-title="balances.list-first.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'balances.list-first.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="mt-2 mb-4">
            <button class="add-icon-button mr-2" color="primary" (click)="onToggleSAG()" mat-flat-button
              matTooltip="{{ 'balances.list-first.sagbtn' | translate }}" matTooltipPosition="above">
              {{ 'balances.list-first.sagbtn' | translate }}
            </button>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportBalances')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="number"
                matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="number">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'balances.fields.number' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.number }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="number" matInput [formControl]="numberFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(numberFilter)"
                        class="reset-input-icon" *ngIf="numberFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="property">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'balances.fields.property' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a routerLink="../../properties/{{ element.property?._id}}/home">
                      {{ element.property?.name }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="propertyFilter" [matAutocomplete]="propertyAuto">
                      <mat-autocomplete autoActiveFirstOption #propertyAuto="matAutocomplete"
                        [displayWith]="displayFn.bind(this)" (onSelectionChange)="onPropertyFilterSelected($event)">
                        <mat-option *ngIf="propertyIsLoading" class="is-loading">
                          <mat-spinner diameter="50"></mat-spinner>
                        </mat-option>
                        <ng-container *ngIf="!propertyIsLoading">
                          <mat-option *ngFor="let property of availableProperties" [value]="property"
                            (onSelectionChange)="onPropertyFilterSelected($event)">
                            <small>{{ property.name }}</small>
                          </mat-option>
                        </ng-container>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(propertyFilter)"
                        class="reset-input-icon" *ngIf="propertyFilter.value"></mat-icon>
                    </mat-form-field>
                    <!-- <mat-form-field class="filter" >
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="propertyFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(propertyFilter)"
                        class="reset-input-icon" *ngIf="propertyFilter.value"></mat-icon>
                    </mat-form-field> -->
                  </td>
                </ng-container>
                <ng-container matColumnDef="company">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'balances.fields.company' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a routerLink="../../companies/detail/{{ element.property?.admin?.company?._id}}">
                      {{ element.property?.admin?.company?.name }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="companyFilter" [matAutocomplete]="companyAuto">
                      <mat-autocomplete autoActiveFirstOption #companyAuto="matAutocomplete"
                        [displayWith]="displayCompanyFn.bind(this)"
                        (onSelectionChange)="onCompanyFilterSelected($event)">
                        <mat-option *ngIf="companyIsLoading" class="is-loading">
                          <mat-spinner diameter="50"></mat-spinner>
                        </mat-option>
                        <ng-container *ngIf="!companyIsLoading">
                          <mat-option *ngFor="let company of availableCompanies" [value]="company"
                            (onSelectionChange)="onCompanyFilterSelected($event)">
                            <small>{{ company.name }}</small>
                          </mat-option>
                        </ng-container>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(companyFilter)"
                        class="reset-input-icon" *ngIf="companyFilter.value"></mat-icon>
                    </mat-form-field>
                    <!-- <mat-form-field class="filter" >
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="companyFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(companyFilter)"
                        class="reset-input-icon" *ngIf="companyFilter.value"></mat-icon>
                    </mat-form-field> -->
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'balances.fields.status' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-chip-list class="d-block py-2 px-1">
                      <mat-chip *ngIf="element.status.includes('open');" selected class="mat-chip-sm chip-green">
                        {{ 'balances.status.open' | translate }}
                      </mat-chip>
                      <mat-chip *ngIf="element.status.includes('pending');" selected class="mat-chip-sm chip-yellow">
                        {{ 'balances.status.pending' | translate }}
                      </mat-chip>
                      <mat-chip *ngIf="element.status.includes('closed');" selected class="mat-chip-sm chip-red">
                        {{ 'balances.status.closed' | translate }}
                      </mat-chip>
                    </mat-chip-list>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    
                  </td>
                </ng-container>
                <ng-container matColumnDef="totalDocsInserted">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'balances.fields.totalDocsInserted' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.property?.totalDocsInserted ? element.property.totalDocsInserted : 0 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="number" matInput [formControl]="totalDocsInsertedFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(totalDocsInsertedFilter)"
                        class="reset-input-icon" *ngIf="totalDocsInsertedFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="total">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'balances.fields.total' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.total.toFixed(2) }} <mat-label matSuffix>€</mat-label>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput type="number" [formControl]="totalFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(totalFilter)"
                        class="reset-input-icon" *ngIf="totalFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.words.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element">{{ element.createdAt | dateTimeFormat }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="createdAtFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(createdAtFilter)"
                        class="reset-input-icon" *ngIf="createdAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5">{{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <a [routerLink]="'../detail/' + element._id" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->